import { useQuery } from "react-query";
import axios from "axios";
import { useAuth0 } from "@auth0/auth0-react";

export function useZoneCalendar() {
  const { getAccessTokenSilently } = useAuth0();

  return useQuery(
    ["zone-calendar"],
    async () => {
      const token = await getAccessTokenSilently();
      const { data } = await axios.get(
        `${process.env.REACT_APP_ENDPOINT}/api/drought-declaration/zone-calendar`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      return data;
    },
    {
      staleTime: 5 * 60 * 1000, // 5 minutes
      cacheTime: 10 * 60 * 1000, // 10 minutes
      enabled: true,
    }
  );
}
